module.exports = __webpack_public_path__ + "img/Curso-de-Capacitacion-del-Sistema-.21e238bd.svg";